export function Disclaimer({ message }: { message?: string }) {
  return <p className='mx-4 mb-16 italic text-gray-500'>{message}</p>;
}
